// extracted by mini-css-extract-plugin
export default {"container":"Favorite_container__LSnQb"};